<template>
  <expandable header="MLC Notification Log" class="mb-10">
    <div v-if="loading" class="text-center py-4">
      <b-spinner variant="primary" small></b-spinner>
    </div>
    <div v-else-if="notifications.length === 0" class="text-center py-3">
      <p class="text-muted mb-0">No notifications sent yet.</p>
    </div>
    <b-table
      v-else
      :items="notifications"
      :fields="fields"
      small
      striped
      responsive
      hover
    >
      <template #cell(notification_type)="data">
        <b-badge :variant="data.value === 'EMAIL' ? 'info' : 'success'">
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(recipient_type)="data">
        {{ formatLabel(data.value) }}
      </template>
      <template #cell(notification_status)="data">
        <MLCNotificationStatus :status="data.value" />
      </template>
      <template #cell(created_on)="data">
        {{ formatDate(data.value) }}
      </template>
      <template #cell(actions)="data">
        <ResendNotificationButton
          v-if="data.item.notification_status === 'FAILED'"
          :notification-id="data.item.notification_id"
          @resent="fetchNotifications"
        />
      </template>
    </b-table>
  </expandable>
</template>

<script>
import donorService from "../../../assets/services/donor.service";
import Expandable from "../../Expandable.vue";
import MLCNotificationStatus from "./MLCNotificationStatus.vue";
import ResendNotificationButton from "./ResendNotificationButton.vue";

export default {
  name: "MLCNotificationLog",
  components: {
    Expandable,
    MLCNotificationStatus,
    ResendNotificationButton,
  },
  props: {
    donorRegistrationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      notifications: [],
      fields: [
        { key: "notification_type", label: "Channel" },
        { key: "recipient_type", label: "Recipient Type" },
        { key: "recipient_contact", label: "Contact" },
        { key: "notification_status", label: "Status" },
        { key: "created_on", label: "Sent At" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  methods: {
    formatLabel(contactType) {
      if (!contactType) return "";
      return contactType
        .split("_")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(" ");
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      let d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async fetchNotifications() {
      if (!this.donorRegistrationId) return;
      this.loading = true;
      try {
        const { data } = await donorService.getMLCNotificationLog({
          donor_registration_id: this.donorRegistrationId,
        });
        if (data.status && data.list) {
          this.notifications = data.list;
        }
      } catch (error) {
        // silent
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchNotifications();
  },
};
</script>
